import BlogComponent from "../components/blog.js";
import FiltersComponent from "../components/filters.js";
import HeaderComponent from "../components/header.js";
import HeroComponent from "../components/hero.js";
import MenuComponent from "../components/menu.js";
import ScrollAnimationsComponent from "../components/scrollAnimations.js";
import ShowreelComponent from "../components/showreel.js";
import SplittingComponent from "../components/splitting.js";
import StackComponent from "../components/stack.js";
import TestimonialComponent from "../components/testimonial.js";
import MapsComponent from "../components/maps.js"; // Iubenda Notices
import VideoComponent from "../components/video.js"; // Iubenda Notices

class ComponentsRegistry {
    constructor() {
        this.list = [
            new FiltersComponent(),
            new HeaderComponent(),
            new HeroComponent(),
            new BlogComponent(), // blog deve stare dopo hero, altrimenti sbrocca
            new MenuComponent(),
            new ScrollAnimationsComponent(),
            new ShowreelComponent(),
            new SplittingComponent(),
            new StackComponent(),
            new TestimonialComponent(),
            new MapsComponent(),
            new VideoComponent(),
        ];
    }

    init() {
        this.list.forEach(c => typeof c.init === "function" && c.init());
    }

    beforeTransition() {
        this.list.forEach(c => typeof c.beforeTransition === "function" && c.beforeTransition());
    }

    onResize() {
        this.list.forEach(c => typeof c.onResize === "function" && c.onResize());
    }
}

let instance;

export default () => {
    if (!instance) {
        instance = new ComponentsRegistry();

        window.addEventListener("mtl.resized", () => {
            instance.onResize();
        });
    }

    return instance;
}
